import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import store from "@/store";
import { getCookie } from "@/utils/utils";
import { isNeedChangePassword } from "@/utils/account";

Vue.use(Router);

function swallowNavError(err) {
  if (
    err &&
    (err.name === "NavigationDuplicated" ||
      (err.message && err.message.indexOf("Redirected") !== -1))
  ) {
    return err;
  }
  return Promise.reject(err);
}

const rawPush = Router.prototype.push;
Router.prototype.push = function push(location, onComplete, onAbort) {
  if (onComplete || onAbort) {
    return rawPush.call(this, location, onComplete, onAbort);
  }
  return rawPush.call(this, location).catch(swallowNavError);
};
const rawReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onComplete, onAbort) {
  if (onComplete || onAbort) {
    return rawReplace.call(this, location, onComplete, onAbort);
  }
  return rawReplace.call(this, location).catch(swallowNavError);
};

const publicRoutes = ["/login", "/register"];
const pageRouter = new Router({
  routes,
});
pageRouter.beforeEach((to, from, next) => {
  if (publicRoutes.includes(to.path)) {
    next();
    return;
  }
  let data = getCookie("loginAccountInfo");
  try {
    data = JSON.parse(data);
  } catch (error) {
    data = null;
  }
  const account = store.state?.loginAccountInfo?.token
    ? store.state.loginAccountInfo
    : data;
  const isLogin = !!(account && account.token);
  if (!isLogin) {
    next("/login");
    return;
  }
  if (isNeedChangePassword(account) && to.path !== "/personal") {
    if (from.path === "/personal") {
      next(false);
      return;
    }
    next("/personal");
    return;
  }
  next();
});
export default pageRouter;
